<script>
export default {
  data() {
    return {
      isPasswordVisible: false,
      MonthSet: ["4 Months", "5 Months", "6 Months"],
      TimeSelc: ["30 Min", "40 Min", "50 Min"],
      SetSel: ["30 Min", "40 Min", "50 Min"],
    };
  },
  methods: {
    togglePasswordVisibility() {
      this.isPasswordVisible = !this.isPasswordVisible;
    },
  },
};
</script>
<template>
  <div class="provider-page">
    <provider-sidebar></provider-sidebar>
    <provider-header></provider-header>
    <!-- Page Wrapper -->
    <div class="page-wrapper">
      <div class="content container-fluid">
        <div class="row">
          <div class="d-flex justify-content-between align-items-center flex-wrap mb-4">
            <h5>Appointment Settings</h5>
          </div>
        </div>
        <div class="row">
          <div class="col-xl-6 col-lg-6 d-flex">
            <!-- Appointment Settings -->
            <div class="appointment-setting-list flex-fill">
              <div class="appoint-wrapper">
                <h5>Appointment Time Intervals</h5>
                <p>Set the appointment time intervals</p>
              </div>
              <div class="form-group">
                <vue-select :options="TimeSelc" id="timeselc" placeholder="30 Min" />
              </div>
            </div>
          </div>
          <div class="col-xl-6 col-lg-6 d-flex">
            <div class="appointment-setting-list flex-fill">
              <div class="appoint-wrapper">
                <h5>Minimum Advance Booking Time</h5>
                <p>Minimum advance booking time (1 hours to 10 days)</p>
              </div>
              <div class="form-group">
                <vue-select :options="SetSel" id="setsel" placeholder="30 Min" />
              </div>
            </div>
          </div>

          <div class="col-xl-6 col-lg-6 d-flex">
            <div class="appointment-setting-list flex-fill">
              <div class="appoint-wrapper">
                <h5>Appointment Auto Confirm</h5>
                <p>Enable/disable appointment auto confirm</p>
              </div>
              <div class="d-flex align-items-center form-check form-switch">
                <input type="checkbox" id="status-one" class="form-check-input" />
              </div>
            </div>
          </div>

          <div class="col-xl-6 col-lg-6 d-flex">
            <div class="appointment-setting-list flex-fill">
              <div class="appoint-wrapper">
                <h5>Allow Multiple Booking for Same Time Slot</h5>
                <p>Set the appointment time intervals</p>
              </div>
              <div class="d-flex align-items-center form-check form-switch">
                <input type="checkbox" id="status-two" class="form-check-input" />
              </div>
            </div>
          </div>

          <div class="col-xl-6 col-md-6 d-flex">
            <div class="appointment-setting-list flex-fill">
              <div class="appoint-wrapper">
                <h5>Maximum Advance Booking Time</h5>
                <p>Set maximum advance booking time (upto 5 years)</p>
              </div>
              <div class="form-group">
                <vue-select :options="MonthSet" id="monthset" placeholder="4 Months" />
              </div>
            </div>
          </div>

          <!-- /Appointment Settings -->
        </div>
      </div>
    </div>

    <!-- /Page Wrapper -->
    <!-- Delete Account -->
    <div class="modal fade custom-modal" id="del-account">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div
            class="modal-header d-flex align-items-center justify-content-between border-bottom"
          >
            <h5 class="modal-title">Delete Account</h5>
            <a href="javascript:void(0);" data-bs-dismiss="modal" aria-label="Close"
              ><i class="ti ti-circle-x-filled fs-20"></i
            ></a>
          </div>
          <form action="javascript:void(0);">
            <div class="modal-body">
              <p class="mb-3">
                Are you sure you want to delete This Account? To delete your account, Type
                your password.
              </p>
              <div class="mb-0">
                <label class="form-label">Password</label>
                <div class="pass-group">
                  <input
                    :type="isPasswordVisible ? 'text' : 'password'"
                    class="form-control pass-input"
                    placeholder="*************"
                  />
                  <span
                    @click="togglePasswordVisibility"
                    :class="
                      isPasswordVisible
                        ? 'toggle-password feather-eye'
                        : 'toggle-password feather-eye-off'
                    "
                  ></span>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <a
                href="javascript:void(0);"
                class="btn btn-light me-2"
                data-bs-dismiss="modal"
                >Cancel</a
              >
              <button type="submit" class="btn btn-dark" data-bs-dismiss="modal">Delete Account</button>
            </div>
          </form>
        </div>
      </div>
    </div>
    <!-- /Delete Account -->
  </div>
</template>
